// initial state
const state = {
  exam: {
    question: {
      questionType: [{key: 0, value: '单选题'}, {key: 1, value: '多选题'}, {key: 2, value: '判断题'}, {
        key: 3, value: '简答题'
      }],
      classType: [{key: 0, value: '培训'}, {key: 1, value: '督导'}],
      paperType: [{key: 0, value: '固定试卷'}, {key: 1, value: '时段试卷'}, {key: 2, value: '任务试卷'}],
      difficultType: [{key: 1, value: '简单'}, {key: 2, value: '容易'}, {key: 3, value: '中等'}, {
        key: 4, value: '困难'
      }, {key: 5, value: '非常困难'}],
      editUrlEnum: [{key: 1, value: '/exam/question/edit/singleChoice', name: '单选题'}, {
        key: 2,
        value: '/exam/question/edit/multipleChoice',
        name: '多选题'
      }, {key: 3, value: '/exam/question/edit/trueFalse', name: '判断题'}, {
        key: 4,
        value: '/exam/question/edit/shortAnswer',
        name: '简答题'
      }]
    },
    paper: {
      status: [{key: 0, value: '待发布'}, {key: 1, value: '已发布'}, {key: 2, value: '已撤回'}],
      types: [{key: 0, value: '固定试卷'}, {key: 1, value: '时段试卷'}],
    },
    answer: {
      types: [{key: 0, value: '课程考核'}],
    },
    review: {
      types: [{key: 0, value: '未批阅'},{key: 1, value: '已批阅'}],
    },
    result: {
      types: [{key: 0, value: '合格'},{key: 1, value: '不合格'}],
    }
  }
}

// getters
const getters = {
  enumFormat: (state) => (arrary, key) => {
    return format(arrary, key)
  }
}

// actions
const actions = {}

// mutations
const mutations = {}

const format = function (array, key) {
  for (let item of array) {
    if (item.key === key) {
      return item.value
    }
  }
  return null
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/enumItem.js